import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, trackEvent } from "@/lib/analytics";

const QUOTE_TESTID = /quote-btn-|get-quote|request-quote|request-customization|enquire/;
const QUOTE_TEXT = ["request a quote", "get a quote", "enquire now", "request customization"];

let lastTrackedPath = null;

const AnalyticsTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (lastTrackedPath === pathname) return;
    lastTrackedPath = pathname;
    trackPageView(pathname);
    if (pathname === "/contact") trackEvent("contact_page_view", { page_path: pathname });
    if (pathname === "/products") trackEvent("products_page_view", { page_path: pathname });
  }, [pathname]);

  useEffect(() => {
    const handler = (e) => {
      const el = e.target.closest("a, button");
      if (!el) return;
      const testid = el.getAttribute("data-testid") || "";
      const href = el.getAttribute("href") || "";
      if (href.includes("Amazing-Grace-Product-Catalogue.pdf")) {
        trackEvent("catalogue_pdf_download", {
          button_id: testid,
          page_path: window.location.pathname,
        });
        return;
      }
      const text = (el.textContent || "").trim().toLowerCase();
      if (QUOTE_TESTID.test(testid) || QUOTE_TEXT.some((t) => text.includes(t))) {
        trackEvent("quote_button_click", {
          button_id: testid || text.slice(0, 50),
          page_path: window.location.pathname,
        });
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return null;
};

export default AnalyticsTracker;
